module.exports = __webpack_public_path__ + "media/icons/arrow-badge-right-a96b1e0c.png";